export default "__VITE_ASSET__bVdWBYoA__"